<template>
  <div>
    <StatNav style="margin-bottom:15px;" />

    <div shadow="never" class="filter-form">
      <el-row :gutter="20">
        <el-col :span="6">
          <label class="label">
            {{ $t('date') }}
          </label>
          <el-date-picker
              v-model="pickerModel"
              :clearable="false"
              value-format="yyyy-MM-dd"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="-"
              start-placeholder="Start date"
              end-placeholder="End date"
              :picker-options="pickerOptions" style="width: 100%">
          </el-date-picker>
        </el-col>
        <el-col :span="4">
          <label class="label">
            {{ $t('period') }}
          </label>
          <el-select v-model="model.period" style="width: 100%">
            <el-option
                v-for="item in periods"
                :key="item.id"
                :label="$t(item.name)"
                :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <label class="label">
            {{ $t('group_by') }}
          </label>
          <el-select v-model="model.groups" multiple :placeholder="$t('no_grouping')" style="width: 100%">
            <el-option
                v-for="item in groups"
                :key="item.id"
                :label="item.name ? $t(item.name) : item.id"
                :value="item.id">
            </el-option>
          </el-select>
        </el-col>

        <el-col :span="6">
          <el-button type="default" @click="expandedVisible=!expandedVisible" :icon="expandedVisible ? 'el-icon-more-outline' : 'el-icon-more'"></el-button>
          <el-button type="primary" @click="getStat()" icon="el-icon-refresh">{{ $t('refresh') }}</el-button>
        </el-col>
      </el-row>

      <el-row :gutter="20" style="margin-top:15px;" v-show="expandedVisible">
        <el-col :span="4">
          <label class="label">
            {{ $t('streams') }}
          </label>
          <el-select v-model="model.streamIDs" multiple :placeholder="$t('all')" style="width: 100%">
            <el-option
                v-for="item in streams"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <label class="label">
            {{ $t('offers') }}
          </label>
          <el-select v-model="model.offerIDs" multiple :placeholder="$t('all')" style="width: 100%">
            <el-option
                v-for="item in filters.offers"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <label class="label">
            {{ $t('landings') }}
          </label>
          <el-select v-model="model.landingIDs" multiple :placeholder="$t('all')" style="width: 100%">
            <el-option
                v-for="item in landings"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <label class="label">
            {{ $t('countries') }}
          </label>
          <el-select v-model="model.countryIDs" multiple :placeholder="$t('all')" style="width: 100%">
            <el-option
                v-for="item in filters.countries"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              <span class="m-r-xs flag-icon" :class="'flag-icon-' + item.id | lowercase"></span> {{item.name}}
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <label class="label">
            {{ $t('device_type') }}
          </label>
          <el-select v-model="model.deviceTypes" multiple :placeholder="$t('all')" style="width: 100%">
            <el-option :label="$t('device_types.desktop')" value="desktop"></el-option>
            <el-option :label="$t('device_types.mobile')" value="mobile"></el-option>
            <el-option :label="$t('device_types.tablet')" value="tablet"></el-option>
          </el-select>
        </el-col>
      </el-row>

      <el-row :gutter="20" style="margin-top:15px;" v-show="expandedVisible">
        <el-col :span="4">
          <label class="label">
            Source
          </label>
          <el-input v-model="model.source"></el-input>
        </el-col>
        <el-col :span="4">
          <label class="label">
            Sub ID 1
          </label>
          <el-input v-model="model.sub1"></el-input>
        </el-col>
        <el-col :span="4">
          <label class="label">
            Sub ID 2
          </label>
          <el-input v-model="model.sub2"></el-input>
        </el-col>
        <el-col :span="4">
          <label class="label">
            Sub ID 3
          </label>
          <el-input v-model="model.sub3"></el-input>
        </el-col>
        <el-col :span="4">
          <label class="label">
            Sub ID 4
          </label>
          <el-input v-model="model.sub4"></el-input>
        </el-col>
        <el-col :span="4">
          <label class="label">
            Sub ID 5
          </label>
          <el-input v-model="model.sub4"></el-input>
        </el-col>
      </el-row>

    </div>


    <el-card shadow="never" v-loading="loading" v-if="!data.report.length">
      <div style="text-align: center; color: #8F9298">{{ $t('el.table.emptyText') }}</div>
    </el-card>

    <div class="el-table el-table--enable-row-hover el-table--enable-row-transition " v-loading="loading" v-if="data.report.length">

      <div class="el-table__body-wrapper is-scrolling-none">
        <table cellspacing="0" cellpadding="0" border="0" class="el-table__body" style="width: 100%;">
          <thead class="has-gutter">
          <tr>
            <th rowspan="2" class="is-leaf is-sortable" @click="changeSorting('period')" :class="selectedCls('period')" v-if="columns.includes('period')">
              <div class="cell">
                {{ $t('period') }}
                <span class="caret-wrapper"><i class="sort-caret ascending"></i><i class="sort-caret descending"></i></span>
              </div>
            </th>
            <th class="is-leaf is-sortable" @click="changeSorting('stream_id')" :class="selectedCls('stream_id')" v-if="columns.includes('stream')">
              <div class="cell">
                {{ $t('stream')}}
                <span class="caret-wrapper"><i class="sort-caret ascending"></i><i class="sort-caret descending"></i></span>
              </div>
            </th>
            <th class="is-leaf is-sortable" @click="changeSorting('offer_id')" :class="selectedCls('offer_id')" v-if="columns.includes('offer')">
              <div class="cell">
                {{ $t('offer')}}
                <span class="caret-wrapper"><i class="sort-caret ascending"></i><i class="sort-caret descending"></i></span>
              </div>
            </th>
            <th class="is-leaf is-sortable" @click="changeSorting('landing_id')" :class="selectedCls('landing_id')" v-if="columns.includes('landing')">
              <div class="cell">
                {{ $t('landing')}}
                <span class="caret-wrapper"><i class="sort-caret ascending"></i><i class="sort-caret descending"></i></span>
              </div>
            </th>
            <th class="is-leaf is-sortable" @click="changeSorting('prelanding_id')" :class="selectedCls('prelanding_id')" v-if="columns.includes('prelanding')">
              <div class="cell">
                {{ $t('prelanding')}}
                <span class="caret-wrapper"><i class="sort-caret ascending"></i><i class="sort-caret descending"></i></span>
              </div>
            </th>
            <th class="is-leaf is-sortable" @click="changeSorting('browser_id')" :class="selectedCls('browser_id')" v-if="columns.includes('browser')">
              <div class="cell">
                {{ $t('browser')}}
                <span class="caret-wrapper"><i class="sort-caret ascending"></i><i class="sort-caret descending"></i></span>
              </div>
            </th>
            <th class="is-leaf is-sortable" @click="changeSorting('device_os_id')" :class="selectedCls('device_os_id')" v-if="columns.includes('device_os')">
              <div class="cell">
                {{ $t('device_os')}}
                <span class="caret-wrapper"><i class="sort-caret ascending"></i><i class="sort-caret descending"></i></span>
              </div>
            </th>
            <th class="is-leaf is-sortable" @click="changeSorting('device_type_id')" :class="selectedCls('device_type_id')" v-if="columns.includes('device_type')">
              <div class="cell">
                {{ $t('device_type')}}
                <span class="caret-wrapper"><i class="sort-caret ascending"></i><i class="sort-caret descending"></i></span>
              </div>
            </th>
            <th class="is-leaf is-sortable" @click="changeSorting('country_id')" :class="selectedCls('country_id')" v-if="columns.includes('country')">
              <div class="cell">
                {{ $t('country')}}
                <span class="caret-wrapper"><i class="sort-caret ascending"></i><i class="sort-caret descending"></i></span>
              </div>
            </th>
            <th class="is-leaf is-sortable" @click="changeSorting('source')" :class="selectedCls('source')" v-if="columns.includes('source')">
              <div class="cell">
                Source
                <span class="caret-wrapper"><i class="sort-caret ascending"></i><i class="sort-caret descending"></i></span>
              </div>
            </th>
            <th class="is-leaf is-sortable" @click="changeSorting('sub1')" :class="selectedCls('sub1')" v-if="columns.includes('sub1')">
              <div class="cell">
                sub1
                <span class="caret-wrapper"><i class="sort-caret ascending"></i><i class="sort-caret descending"></i></span>
              </div>
            </th>
            <th class="is-leaf is-sortable" @click="changeSorting('sub2')" :class="selectedCls('sub2')" v-if="columns.includes('sub2')">
              <div class="cell">
                sub2
                <span class="caret-wrapper"><i class="sort-caret ascending"></i><i class="sort-caret descending"></i></span>
              </div>
            </th>
            <th class="is-leaf is-sortable" @click="changeSorting('sub3')" :class="selectedCls('sub3')" v-if="columns.includes('sub3')">
              <div class="cell">
                sub3
                <span class="caret-wrapper"><i class="sort-caret ascending"></i><i class="sort-caret descending"></i></span>
              </div>
            </th>
            <th class="is-leaf is-sortable" @click="changeSorting('sub4')" :class="selectedCls('sub4')" v-if="columns.includes('sub4')">
              <div class="cell">
                sub4
                <span class="caret-wrapper"><i class="sort-caret ascending"></i><i class="sort-caret descending"></i></span>
              </div>
            </th>
            <th class="is-leaf is-sortable" @click="changeSorting('sub5')" :class="selectedCls('sub5')" v-if="columns.includes('sub5')">
              <div class="cell">
                sub5
                <span class="caret-wrapper"><i class="sort-caret ascending"></i><i class="sort-caret descending"></i></span>
              </div>
            </th>

            <th class="is-leaf is-sortable" @click="changeSorting('visits')" :class="selectedCls('visits')">
              <div class="cell">
                {{ $t('visits') }}
                <span class="caret-wrapper"><i class="sort-caret ascending"></i><i class="sort-caret descending"></i></span>
              </div>
            </th>
            <th class="is-leaf is-sortable" @click="changeSorting('clicks')" :class="selectedCls('clicks')">
              <div class="cell">
                {{ $t('clicks') }}
                <span class="caret-wrapper"><i class="sort-caret ascending"></i><i class="sort-caret descending"></i></span>
              </div>
            </th>
            <th class="is-leaf is-sortable" @click="changeSorting('CR')" :class="selectedCls('CR')">
              <div class="cell">
                CR
                <span class="caret-wrapper"><i class="sort-caret ascending"></i><i class="sort-caret descending"></i></span>
              </div>
            </th>
            <th class="is-leaf is-sortable" @click="changeSorting('registrations')" :class="selectedCls('registrations')">
              <div class="cell">
                {{ $t('registrations') }}
                <span class="caret-wrapper"><i class="sort-caret ascending"></i><i class="sort-caret descending"></i></span>
              </div>
            </th>
            <th class="is-leaf is-sortable" @click="changeSorting('FD')" :class="selectedCls('FD')">
              <div class="cell">
                {{ $t('subscriptions') }}
                <span class="caret-wrapper"><i class="sort-caret ascending"></i><i class="sort-caret descending"></i></span>
              </div>
            </th>
            <th class="is-leaf is-sortable" @click="changeSorting('RD')" :class="selectedCls('RD')">
              <div class="cell">
                {{ $t('renewals') }}
                <span class="caret-wrapper"><i class="sort-caret ascending"></i><i class="sort-caret descending"></i></span>
              </div>
            </th>
            <th class="is-leaf is-sortable" @click="changeSorting('usd_income')" :class="selectedCls('usd_income')">
              <div class="cell">
                {{ $t('income') }}, $
                <span class="caret-wrapper"><i class="sort-caret ascending"></i><i class="sort-caret descending"></i></span>
              </div>
            </th>
            <th class="is-leaf is-sortable" @click="changeSorting('rub_income')" :class="selectedCls('rub_income')">
              <div class="cell">
                {{ $t('income') }}, ₽
                <span class="caret-wrapper"><i class="sort-caret ascending"></i><i class="sort-caret descending"></i></span>
              </div>
            </th>
          </tr>
          </thead>
          <tbody>
          <tr class="el-table__row" v-for="(item, index) in data.report" :key="index">
            <td v-if="columns.includes('period')">
              <div class="cell"><i class="el-icon-date" :class="{'el-icon-time': item.period.toString().match( /:/i )}"></i> {{ item.period }}</div>
            </td>
            <td v-if="columns.includes('stream')">
              <div class="cell">{{item.stream.name}}</div>
            </td>
            <td v-if="columns.includes('offer')">
              <div class="cell">
                <router-link :to="{name: 'offer-view', params: { id: item.offer.id }}" target="_blank">
                  {{item.offer.name}}
                </router-link>
              </div>
            </td>
            <td v-if="columns.includes('landing')">
              <div class="cell">{{item.landing.name}}</div>
            </td>
            <td v-if="columns.includes('prelanding')">
              <div class="cell">{{item.prelanding.name}}</div>
            </td>
            <td v-if="columns.includes('browser')">
              <div class="cell">{{item.browser}}</div>
            </td>
            <td v-if="columns.includes('device_os')">
              <div class="cell">{{item.device_os}}</div>
            </td>
            <td v-if="columns.includes('device_type')">
              <div class="cell">{{$t('device_types.' + item.device_type)}}</div>
            </td>
            <td v-if="columns.includes('country')">
              <div class="cell">{{item.country.name}}</div>
            </td>
            <td v-if="columns.includes('source')">
              <div class="cell">{{item.source}}</div>
            </td>
            <td v-if="columns.includes('sub1')">
              <div class="cell">{{item.sub1}}</div>
            </td>
            <td v-if="columns.includes('sub2')">
              <div class="cell">{{item.sub2}}</div>
            </td>
            <td v-if="columns.includes('sub3')">
              <div class="cell">{{item.sub3}}</div>
            </td>
            <td v-if="columns.includes('sub4')">
              <div class="cell">{{item.sub4}}</div>
            </td>
            <td v-if="columns.includes('sub5')">
              <div class="cell">{{item.sub5}}</div>
            </td>
            <td>
              <div class="cell">{{ $n(item.visits) }}</div>
            </td>
            <td>
              <div class="cell">{{ $n(item.clicks) }}</div>
            </td>
            <td>
              <div class="cell">{{ item.CR | n(2) }}%</div>
            </td>
            <td>
              <div class="cell">{{ item.registrations }}</div>
            </td>
            <td>
              <div class="cell">{{ item.FD }}</div>
            </td>
            <td>
              <div class="cell">{{ item.RD }}</div>
            </td>
            <td>
              <div class="cell">{{ item.usd_income | n(2) }} $</div>
            </td>
            <td>
              <div class="cell">{{ item.rub_income | n(2) }} ₽</div>
            </td>
          </tr>
          </tbody>
          <tfoot>
          <tr>
            <td v-if="columns.includes('period')">
              <div class="cell">{{ $t('total') }}</div>
            </td>
            <td v-if="columns.includes('stream')">
              <div class="cell">-</div>
            </td>
            <td v-if="columns.includes('offer')">
              <div class="cell">-</div>
            </td>
            <td v-if="columns.includes('landing')">
              <div class="cell">-</div>
            </td>
            <td v-if="columns.includes('prelanding')">
              <div class="cell">-</div>
            </td>
            <td v-if="columns.includes('browser')">
              <div class="cell">-</div>
            </td>
            <td v-if="columns.includes('device_os')">
              <div class="cell">-</div>
            </td>
            <td v-if="columns.includes('device_type')">
              <div class="cell">-</div>
            </td>
            <td v-if="columns.includes('country')">
              <div class="cell">-</div>
            </td>
            <td v-if="columns.includes('source')">
              <div class="cell">-</div>
            </td>
            <td v-if="columns.includes('sub1')">
              <div class="cell">-</div>
            </td>
            <td v-if="columns.includes('sub2')">
              <div class="cell">-</div>
            </td>
            <td v-if="columns.includes('sub3')">
              <div class="cell">-</div>
            </td>
            <td v-if="columns.includes('sub4')">
              <div class="cell">-</div>
            </td>
            <td v-if="columns.includes('sub5')">
              <div class="cell">-</div>
            </td>
            <td>
              <div class="cell">{{ $n(data.totalColumn.visits) }}</div>
            </td>
            <td>
              <div class="cell">{{ $n(data.totalColumn.clicks) }}</div>
            </td>
            <td>
              <div class="cell">{{ data.totalColumn.CR | n(2) }}%</div>
            </td>
            <td>
              <div class="cell">{{ data.totalColumn.registrations }}</div>
            </td>
            <td>
              <div class="cell">{{ data.totalColumn.FD }}</div>
            </td>
            <td>
              <div class="cell">{{ data.totalColumn.RD }}</div>
            </td>
            <td>
              <div class="cell">{{ data.totalColumn.usd_income | n(2) }} $</div>
            </td>
            <td>
              <div class="cell">{{ data.totalColumn.rub_income | n(2) }} ₽</div>
            </td>
          </tr>
          </tfoot>
        </table>
      </div>
    </div>

    <div style="margin-top: 10px; text-align: center" v-if="moreVisible">
      <el-button round @click="more" :loading="loading_next">загрузить еще данные</el-button>
    </div>

    <!--<div style="font-size: 11px; color: #9b9ea5" @click="debug=!debug">{{ data.info.elapsed }}</div>-->
    <!--<div v-if="debug" v-html="data.dev.sql"></div>-->
  </div>
</template>

<script>
import PickerOptions from '../mixins/PickerOptions'
import StatNav from '../components/StatNav'
import qs from 'qs'
import getSymbolFromCurrency from 'currency-symbol-map';

export default {
  name: "Statistic",
  mixins: [
    PickerOptions
  ],
  components: {
    StatNav
  },
  data () {
    return {
      next: 0,
      debug: false,
      current_currency: '',
      data: {
        report: [],
        totalColumn: {},
        meta: {},
        info: {}
      },
      expandedVisible: false,
      period: 'date',
      order: 'period',
      orderDirection: 'desc',
      //columns: [],
      model: {
        fromDate: null,
        untilDate: null,
        period: 'date',
        streamIDs: [],
        offerIDs: [],
        landingIDs: [],
        countryIDs: [],
        deviceTypeIDs: [],
        currency: localStorage.getItem('currency') ? localStorage.getItem('currency') : 'USD',
      },
      periods: [
        { name: 'no_period',     id: ''},
        { name: 'by_days',     id: 'date'},
        { name: 'by_hour',   id: 'hour'},
        { name: 'by_week',   id: 'week'},
        { name: 'by_month',   id: 'month'},
        { name: 'by_year',   id: 'year'},
        { name: 'by_minute',   id: 'minute'}
      ],
      groups: [
        { name: 'stream',     id: 'stream'},
        { name: 'offer',     id: 'offer'},
        { name: 'landing',   id: 'landing'},
        { name: 'prelanding',   id: 'prelanding'},
        { name: 'country',   id: 'country'},
        { name: 'device_type',   id: 'device_type'},
        { name: 'device_os',   id: 'device_os'},
        { name: 'browser',   id: 'browser'},
        { id: 'source'},
        { id: 'sub1'},
        { id: 'sub2'},
        { id: 'sub3'},
        { id: 'sub4'},
        { id: 'sub5'}
      ],
      loading: false,
      loading_next: false,
      currency: [],
      streams: [],
      filters: {
        landings: [],
        deviceTypes: [],
        countries: [],
        offers: []
      }
    }
  },
  computed: {
    columns() {
      if (this.data.report[0]) {
        return Object.keys(this.data.report[0]);
      }
      return [];
    },
    landings() {
      let offerIDs=this.model.offerIDs;

      if (!offerIDs.length) {
        return this.filters.landings;
      }

      return this.filters.landings.filter(function(item) {
        return offerIDs.filter((function(value){ return value === item.offer_id; })).length;
      });
    },
    moreVisible () {
      return this.data.meta.count!==this.data.meta.countAll && this.data.meta.count===this.data.meta.limit
    }
  },
  created () {
    // this.$axios.get('/currencies', this.model).then((res) => {
    //     this.currency = res.data;
    // });
    this.$axios.get('/streams', this.model).then((res) => {
      this.streams = res.data;
    });

    this.$axios.get('/stat/filters', this.model).then((res) => {
      this.filters = res.data;
    });
  },
  watch: {
    model: {
      handler () {
        localStorage.setItem('currency', this.model.currency);
        this.getStat();
      },
      deep: true
    },
  },
  methods: {
    getStat () {
      this.next = 0;
      this.loading = true;
      this.$axios.get('/stat?' + qs.stringify({ sort: (this.orderDirection === 'desc' ? '-' : '') + this.order, c: this.model }, { encode: false })).then((res) => {
        this.data = res.data;
        this.current_currency = getSymbolFromCurrency(this.model.currency);
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },
    more () {
      this.next+=this.data.meta.limit;
      this.loading_next = true;
      this.$axios.get('/stat?' + qs.stringify({ sort: (this.orderDirection === 'desc' ? '-' : '') + this.order, c: this.model, next: this.next }, { encode: false })).then((res) => {
        this.data.meta = res.data.meta;
        this.data.info = res.data.info;
        this.data.dev = res.data.dev;
        res.data.report.map(item => {
          this.data.report.push(item);
        });
        this.loading_next = false;
      }).catch(() => {

      });
    },
    changeSorting(column) {
      if (this.order === column) {
        this.orderDirection=this.orderDirection === 'asc' ? 'desc' : 'asc';
      } else {
        this.order = column;
        this.orderDirection='desc';
      }
      this.getStat();
    },
    selectedCls(column) {
      if (column === this.order) {
        let sort=this.orderDirection;
        return sort+ 'ending';
      }
      return '';
    }
  }
}
</script>

<style lang="scss" scoped>

</style>